import { useRef, useState, useEffect } from 'react';
import * as THREE from 'three';
import { useFrame } from '@react-three/fiber';

interface MotionWaveProps {
  isActive: boolean;
}

export function MotionWave({ isActive }: MotionWaveProps) {
  const [waves, setWaves] = useState<Array<{ id: number; scale: number; opacity: number }>>([]);
  const nextWaveId = useRef(0);

  useEffect(() => {
    if (isActive) {
      // Add a new wave when motion is detected
      setWaves(prev => [...prev, { id: nextWaveId.current++, scale: 0.5, opacity: 0.8 }]);
    }
  }, [isActive]);

  useFrame(() => {
    setWaves(prev => {
      return prev
        .map(wave => ({
          ...wave,
          scale: wave.scale + 0.05,
          opacity: wave.opacity - 0.02
        }))
        .filter(wave => wave.opacity > 0);
    });
  });

  return (
    <group>
      {waves.map(wave => (
        <mesh key={wave.id} position={[0, 0, 0]}>
          <ringGeometry args={[wave.scale, wave.scale + 0.1, 32]} />
          <meshStandardMaterial
            color="#cc5de8"
            transparent
            opacity={wave.opacity}
            emissive="#cc5de8"
            emissiveIntensity={0.5}
            side={THREE.DoubleSide}
          />
        </mesh>
      ))}
    </group>
  );
} 